<template>
    <div class="roof-search">
        <div class="placeholder-container" v-if="placeholder"></div>
        <div class="roof-search-container" ref="roofContainer">
            <div class="left-content" v-if="leftContent">
                <img
                    @click="popupLeft"
                    :src="showPopupLeft?navImgSelect:navImg"
                    alt
                    class="nav-icon"
                />
            </div>
            <div class="middle-content" v-if="middleContent">
                <i class="iconfont icon-sousuo"></i>
                <!--          <input type="text" v-model="searchValue" placeholder="请输入产品名称" class="input">-->
                <van-field
                    v-model="searchValue"
                    placeholder="输入产品名称"
                    readonly
                    class="input"
                    @click="goRouter('searchProduct')"
                />
            </div>
            <div class="right-content" v-if="rightContent">
                <i class="iconfont icon-shaixuan" @click="tyleFiltrate"></i>
            </div>
            <!-- shaixuan -->
            <!-- <div class="right-sel-main popup-left-container" v-if="showPlan && !showPlanVan">
                <span class="right-sel-btn" :class="actid == item.id?'active-col': ''" @click="selPlan(item,'2')" v-for="item in planList" :key="item.id">{{ item.title }}</span>
            </div> -->
            <!-- 解决方案筛选 -->
            <div class="right-content" v-if="showPlan">
                <i v-show="!showPlanVan" class="iconfont icon-shaixuan" @click="showPlanSel"></i>
                <i v-show="showPlanVan" class="iconfont icon-quxiao" @click="showPlanVan = false"></i>
            </div>
        </div>
        <van-popup v-model="showPlanVan" position="left" :style="{ height: '100%' }">
            <!-- <div class="popup-left-more p-l-20">
                全部分类
            </div> -->
            <div class="popup-left-class ">
                <p class="right-sel-btn m-t-10 p-l-20" @click="selPlan('')">全部</p>
                <p class="right-sel-btn m-t-10 p-l-20" :class="actid == item.id?'active-col': ''" @click="selPlan(item)" v-for="item in planListMore" :key="item.id">{{ item.title }}</p>
            </div>
        </van-popup>
        <van-popup v-model="showPopupLeft" position="left" :style="{ height: '100%' }">
            <div class="popup-left-container">
                <div class="options" @click="goRouter('homeIndex')">首页</div>
                <div class="options" @click="goRouter('productStore')">产品中心</div>
                <div class="options" @click="goRouter('centrifugeHome')">离心直通车</div>
                <div class="options" @click="goRouter('pipetteHome')">移液加速站</div>
                <div class="options" @click="goRouter('solutionHome')">解决方案</div>
                <!-- <div class="options" @click="goRouter('sceneActivity')">小 E 活动</div> -->
                <div class="options" @click="goRouter(hostUrl + '/news1.html')">精选资讯</div>
                <div class="options" @click="goRouter(hostUrl + '/lifeWithYou/index.html#/handbook')">快速操作指南</div>
                <div class="options" @click="goRouter('caseShare')">案例分享</div>
                <wx-open-launch-weapp
                    style="height: 100%;width: 300%;"
                    id="launch-btn"
                    appid="wx78248ab2e6a420ec"
                    username="gh_464305d43974"
                    path="pages/index/index"
                    >
                    <script type="text/wxtag-template">
                        <style>
                            .options {
                                height: 2.6666rem;
                                line-height: 2.6666rem;
                                border-bottom: 1px solid #e0e0e0;
                                padding-left: 1.2666rem;
                                color: #6cc4da;
                                font-size: 15px;
                                font-weight: bold;
                            }
                        </style>
                        <div class="options">仪器保养</div>
                    </script>
                </wx-open-launch-weapp>
                <!-- <div class="options" @click="goRouter(hostUrl + '/lifeWithYou/index.html#/post-service')">仪器保养</div> -->
                <div class="options" @click="goRouter(hostUrl + '/lifeWithYou/index.html#/videoClassify')">视频中心</div>
                <div class="options" @click="goRouter(hostUrl + '/contact.html')">联系我们</div>
                <div class="options" @click="goRouter(hostUrl + '/about.html')">公司介绍</div>
            </div>
        </van-popup>
        <van-popup v-model="showPopupRight" position="left" :style="{ height: '100%' }">
            <div class="popup-right-container">
                <van-tree-select
                    :items="this.$store.state.categoryList"
                    :active-id.sync="activeId"
                    :main-active-index.sync="activeIndex"
                    :height="popupRightHeight"
                    @click-nav="clickNav"
                    @click-item="clickItem"
                />
            </div>
        </van-popup>
    </div>
</template>
<!-- 公众号 JSSDK -->
<script src="https://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<script>
import { getAllCategory } from '@/api/product'
import { setCookie } from '@/libs/util'
import { wxSdkConfig } from '@/libs/wxjssdk'
export default {
    data () {
        return {
            navImg: require('@/assets/img/nav-icon2.png'),
            navImgSelect: require('@/assets/img/nav-icon.png'),
            searchValue: '',
            showPopupLeft: false, // 左侧弹出层
            showPopupRight: false, // 单击右侧弹出层
            popupRightHeight: 500, // 右侧导航筛选的默认高度
            // categoryItems: [],
            activeId: 0,
            activeIndex: 0,
            
            showPlanVan: false, // 显示方案选择
            actid: '',
            hostUrl: window.location.origin
        }
    },
    props: {
        leftContent: {
            type: Boolean,
            default: true
        },
        middleContent: {
            type: Boolean,
            default: true
        },
        rightContent: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: Boolean,
            default: false
        },
        showPlan: {
            type: Boolean,
            default: false
        },
        planListMore: {
            type: Array,
        },
        planList: {
            type: Array,
        }
    },
    watch: {
       
    },
    created () {
        // if (showPlan) {
            // this.getAllCategoryPort()
        // }
          // 获取微信签名
          wxSdkConfig();
       
    },
    mounted () {
        
        var bodyHeight = document.querySelector('body').clientHeight
        var topContentHeight = this.$refs.roofContainer.clientHeight
        this.popupRightHeight = bodyHeight - topContentHeight
    },
    methods: {
        showPlanSel() { // 解决方案
            this.showPlanVan = true
        },
        selPlan(data,type) { // 解决方案
            this.actid = data.id
            this.showPlanVan = false
            this.$emit('handleSolution',data,type)
        },
        // 路由跳转
        goRouter (name) {
            // console.log('路由跳转的参数', name)
            // console.log('当前路由', this.$route)
            if (name.indexOf('http') != -1) {
                window.location.href = name
                return
            }
            if (name !== this.$route.name) {
                this.$router.push(name)
            } else {
                this.showPopupLeft = false
            }
        },
        // 单击了左侧导航
        popupLeft () {
            this.showPopupLeft = !this.showPopupLeft
            this.showPopupRight = false
            this.showPlanVan = false
        },
        // 单击了类别筛选
        tyleFiltrate () {
            this.showPopupRight = !this.showPopupRight
            this.showPopupLeft = false
        },
        // 分类选择导航单击（一级）
        clickNav (index) {
            var children = this.$store.state.categoryList[index].children || ''
            if (!children) {
                var data = this.$store.state.categoryList[index]
                var params = {
                    // title: data.title,
                    parent_category_id: data.id
                }
                // 二级筛选页 数据更新
                params = JSON.stringify(params)
                setCookie('second_category', params)
                this.$emit('secondCategoryChange', true, params)
                this.showPopupRight = false
                this.$toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    duration: 0
                })
            }
        },
        // 分类选择导航单击（二级）
        clickItem (data) {
            // setCookie
            var params = {}
            if (data.id) {
                params = {
                    category_id: data.id,
                    // title: data.title,
                    parent_category_id: data.parent_id
                }
                params = JSON.stringify(params)
                setCookie('second_category', params)
                this.$emit('secondCategoryChange', false, params)
            } else {
                // 单击了全部
                // var parentData = this.$store.state.categoryList.filter(val => {
                //   return val.id === data.parent_id
                // })
                params = {
                    // title: `${parentData[0].title}-${data.title}`,
                    parent_category_id: data.parent_id
                }
                params = JSON.stringify(params)
                setCookie('second_category', params)
                this.$emit('secondCategoryChange', true, params)
            }
            this.showPopupRight = false
            this.$toast.loading({
                message: '加载中...',
                forbidClick: true,
                duration: 0
            })
        },
        // 格式化数据
        formatData (categoryItems) {
            categoryItems = categoryItems.map((val, key, arr) => {
                val.text = val.title
                if (val.children) {
                    val.children.map((val1, key1, arr1) => {
                        val1.text = val1.title
                    })
                }
                return val
            })
            return categoryItems
        },

        /** 网络请求 **/
        // 获取所有类别
        getAllCategoryPort () {
            getAllCategory({ type: 5 })
                .then(res => {
                    
                    // var categoryItems = res
                    // categoryItems = this.formatData(categoryItems)
                    // this.categoryItems = categoryItems
                    let data = JSON.parse(JSON.stringify(res))
                    this.planListMore = res
                    this.planList = data.splice(0,2)
                    // console.log('获取所有类', this.planList)
                })
                .catch(err => {
                    this.$toast('获取类别接口失败')
                    console.log('获取所有类别接口失败', err)
                })
        }
    }
}
</script>

<style lang="scss" scoped>
.m-t-10 {
    margin-top: rem(10);
}
.p-l-20 {
    padding-left: rem(20);
    box-sizing: border-box;
}

.roof-search {
    .placeholder-container {
        width: 100%;
        height: rem(46);
        background: none;
    }
    .roof-search-container {
        display: flex;
        justify-content: space-between;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        z-index: 9999;
        height: rem(46);
        padding: rem(9) 0;
        background: #fff;
        display: flex;
        align-items: center;
        .left-content {
            width: 20%;
            text-align: center;
            .nav-icon {
                width: rem(18);
                height: rem(18);
            }
        }
        .middle-content {
            width: 80%;
            height: 100%;
            border-radius: 4px;
            display: flex;
            align-items: center;
            color: #9d9d9d;
            padding: 0 rem(11);
            background: #f4f4f4;
            .iconfont {
                color: #9d9d9d;
            }
            .van-cell {
                padding-left: rem(8);
            }
            .input {
                background: none;
            }
        }
        .right-content {
            width: 20%;
            text-align: center;
            i {
                font-size: rem(20);
                color: #4d4d4d;
            }
        }
    }
    .popup-left-more {
        padding-top: rem(46);
    }
    .popup-left-container {
        width: rem(186);
        padding-top: rem(46);
        .options {
            height: rem(40);
            line-height: rem(40);
            border-bottom: 1px solid #e0e0e0;
            padding-left: rem(19);
            color: $base-color;
            font-size: 15px;
            font-weight: bold;
        }
    }
    .popup-left-class {
        width: rem(186);
        padding-top: rem(46);
    }
    .popup-right-container {
        padding-top: rem(46);
        width: rem(300);
        // 选中的颜色
        .van-sidebar-item--select {
            border-color: $base-color;
            &:before {
                background: white;
            }
        }
        .van-tree-select__item--active {
            color: $base-color;
        }
        .van-tree-select__item {
            font-weight: normal;
        }
    }
}
.right-sel-main {
    height: rem(40);
    overflow: hidden;
}
.right-sel-btn {
    // display: inline-block;
    // width: rem(80);
    height: rem(35);
    // margin-right: rem(15);
    // line-height: rem(35);
    // text-align: center;
    // color: #0866a7;
    border-bottom: 1px solid #ddd;
    // border-radius: rem(5);
}
.active-col {
    // color: #fff;
    // background-color: #0c68a9;
}

</style>
